import { createServiceStore } from 'common/store';
import { customActions } from './custom-actions';
import { INITIAL_STATE } from './constants';
export var useBalanceAndNotificationStore = createServiceStore({
    initialValues: INITIAL_STATE,
    customActions: customActions,
});
